import { useAtom } from 'jotai';
import { explorerItemsAtom } from "@/state/jotai/atom/explorerItemsAtom.ts";

const useExplorerItems = () => {
  return useAtom(explorerItemsAtom);
};

export default useExplorerItems
